import { Button } from "antd";
import { useLoaderData } from "react-router-dom";
import { BmcApiService } from "../ApiService/BmcService";
import BmcHeader from "./BmcHeader";
import PoweredByEasebuzz from "./PoweredByEasebuzz";
import "../styles/index.css";

const formatAmount = (val) =>
  Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const BmcReceiptPage = () => {
  const data = useLoaderData();

  const handleDownload = () => {
    const base = (process.env.REACT_APP_LAYER_URL || "").replace(/\/$/, "");
    window.open(`${base}/bmc_mumbai/download-receipt/?txn_id=${data.transaction_id}`, "_blank");
  };

  // Not found or payment not successful
  if (!data?.success) {
    return (
      <div className="bmc-wrapper">
        <div className="bmc-card">
          <BmcHeader />
          <div className="bmc-status-body">
            <div className="bmc-status-icon failure">✕</div>
            <p className="bmc-status-title failure">Receipt Not Available</p>
            <p className="bmc-status-subtitle">
              {data?.message || "We could not find the receipt for this payment."}
            </p>
          </div>
          <div className="bmc-footer bmc-status-card-footer">
            For any queries, please contact us at{" "}
            <a href="mailto:contact@mcgm.gov.in">contact@mcgm.gov.in</a>
          </div>
        </div>
        <div className="bmc-status-bottom-bar">
          <span>
            For any queries, please contact us at{" "}
            <a href="mailto:contact@mcgm.gov.in">contact@mcgm.gov.in</a>
          </span>
          <PoweredByEasebuzz />
        </div>
      </div>
    );
  }

  return (
    <div className="bmc-wrapper">
      {/* Mobile-only: Powered by Easebuzz at top right */}
      <div className="bmc-mobile-topbar">
        <PoweredByEasebuzz />
      </div>

      <div className="bmc-card">
        <BmcHeader />

        <div className="bmc-status-body">
          {/* Success icon */}
          <div className="bmc-status-icon success">✓</div>

          <p className="bmc-status-title success">Payment Successful!</p>

          {data.amount && (
            <p className="bmc-status-amount">₹ {formatAmount(data.amount)}</p>
          )}

          {/* Transaction details */}
          <div className="bmc-status-table">
            <div className="bmc-status-row">
              <div className="bmc-info-label">Transaction ID</div>
              <div className="bmc-info-value">{data.transaction_id || "N/A"}</div>
            </div>
            {data.net_amount_debit && Number(data.net_amount_debit) > 0 && (
              <div className="bmc-status-row">
                <div className="bmc-info-label">Total Debited Amount</div>
                <div className="bmc-info-value">₹ {formatAmount(data.net_amount_debit)}</div>
              </div>
            )}
            <div className="bmc-status-row">
              <div className="bmc-info-label">Date and Time</div>
              <div className="bmc-info-value">{data.transaction_date || "N/A"}</div>
            </div>
            <div className="bmc-status-row">
              <div className="bmc-info-label">Section Account Code</div>
              <div className="bmc-info-value">{data.property_account_number || "N/A"}</div>
            </div>
            {data.receipt_no && (
              <div className="bmc-status-row">
                <div className="bmc-info-label">Receipt No</div>
                <div className="bmc-info-value">{data.receipt_no}</div>
              </div>
            )}
          </div>

          {/* Download button */}
          <div className="bmc-action-btns">
            <Button
              className="bmc-btn-primary"
              onClick={handleDownload}
              disabled={!data.receipt_s3_url && !data.transaction_id}
              title={!data.receipt_s3_url ? "Receipt is being generated, please wait" : ""}
            >
              Download Receipt
            </Button>
          </div>
        </div>

        {/* Mobile-only contact footer inside card */}
        <div className="bmc-footer bmc-status-card-footer">
          For any queries, please contact us at{" "}
          <a href="mailto:contact@mcgm.gov.in">contact@mcgm.gov.in</a>
        </div>
      </div>

      {/* Desktop-only: contact left + Powered by Easebuzz right */}
      <div className="bmc-status-bottom-bar">
        <span>
          For any queries, please contact us at{" "}
          <a href="mailto:contact@mcgm.gov.in">contact@mcgm.gov.in</a>
        </span>
        <PoweredByEasebuzz />
      </div>
    </div>
  );
};

export const fetchReceiptData = async ({ request }) => {
  // URL format: /BMC/receipt/?{ebz_pay_id}
  const ebzPayId = new URL(request.url).search.slice(1);
  if (!ebzPayId) return { success: false, message: "Invalid receipt link." };
  const response = await BmcApiService.getReceiptInfo(ebzPayId);
  return response ?? { success: false, message: "Receipt not found." };
};

export default BmcReceiptPage;
